export const PickupRadius = {
  quarterMile: {
    meters: 402,
    miles: '¼ Mile'
  },
  halfMile: {
    meters: 804,
    miles: '½ Mile'
  },
  threeQuarterMile: {
    meters: 1207,
    miles: '¾ Mile'
  },
  oneMile: {
    meters: 1609,
    miles: '1 Mile'
  },
  twoMiles: {
    meters: 3218,
    miles: '2 Miles'
  },
  threeMiles: {
    meters: 4828,
    miles: '3 Miles'
  }
}

export const metersToMilesDiscrete = (meters) => {
  switch (meters) {
    case 402:
      return '¼ Mile'
    case 804:
      return '½ Mile'
    case 1207:
      return '¾ Mile'
    case 1609:
      return '1 Mile'
    case 3218:
      return '2 Miles'
    case 4828:
      return '3 Miles'
    default:
      return (meters / 1609.34).toFixed(2)
  }
}
